import React from 'react';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import WhyChoose from '../components/landing/WhyChoose';
import MidCTA from '../components/landing/MidCTA';
import EmailSignup from '../components/landing/EmailSignup';
import Footer from '../components/landing/Footer';
import MobileStickyCTA from '../components/landing/MobileStickyCTA';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="landing-page">
      <Navbar />
      <Hero />
      <Features />
      <WhyChoose />
      <MidCTA />
      <EmailSignup />
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}

export default LandingPage;
